import { FC, ReactElement } from 'react';
import {
  StyledReferencesContainer,
  StyledLabel,
  StyledText,
  StyledReferencesCell,
  StyledCellInfoContainer,
  StyledReferencesColumn,
  StyledSquare,
} from './ChartReferences.styles';
import { textToTitleCase } from '@modules/study-insights/utils';
import { ChartGroupTotals } from '@common/types';
import { ChartReferencesProps } from './ChartReferences.types';
import { Box } from '@/common/components/base-app';

const ChartReferences: FC<ChartReferencesProps> = ({
  data,
  columnStyles,
  labelStyles,
  referencesColors,
  showPercentage = true,
}) => {
  const renderReference = (item: ChartGroupTotals, index: number): ReactElement => {
    const itemName: string = item.name;

    return (
      <StyledReferencesCell data-testid={`reference-${index}`} key={`reference-${index}`}>
        <Box>
          <StyledSquare css={{ color: `${referencesColors[index % referencesColors.length]}` }} />
        </Box>
        <StyledCellInfoContainer>
          <StyledLabel css={{ ...labelStyles }}>{textToTitleCase(itemName)}</StyledLabel>
          {showPercentage && (
            <StyledText>{`${!isNaN(item.percentage) ? item.percentage.toFixed(1) : 0}%, ${item.total}`}</StyledText>
          )}
        </StyledCellInfoContainer>
      </StyledReferencesCell>
    );
  };

  return (
    <StyledReferencesContainer>
      <StyledReferencesColumn css={{ marginLeft: '55px', ...columnStyles }}>
        {data.length > 6
          ? data.map(
              (reference: ChartGroupTotals) =>
                data.indexOf(reference) <= 3 && renderReference(reference, data.indexOf(reference)),
            )
          : data.map(
              (reference: ChartGroupTotals) =>
                data.indexOf(reference) <= 2 && renderReference(reference, data.indexOf(reference)),
            )}
      </StyledReferencesColumn>
      {data.length > 3 && (
        <StyledReferencesColumn css={{ ...columnStyles }}>
          {data.length > 6
            ? data.map(
                (reference: ChartGroupTotals) =>
                  data.indexOf(reference) > 3 && renderReference(reference, data.indexOf(reference)),
              )
            : data.map(
                (reference: ChartGroupTotals) =>
                  data.indexOf(reference) > 2 && renderReference(reference, data.indexOf(reference)),
              )}
        </StyledReferencesColumn>
      )}
    </StyledReferencesContainer>
  );
};
export default ChartReferences;
